export type TNativeDelayNode = DelayNode;
